export default "__VITE_ASSET__2402368e__"